import { useMemo } from 'react';
import { useDashboardScope } from '../contexts/DashboardScopeContext';
import {
    formatDashboardDateRangeLabel,
    getDashboardPeriodLabel,
    getIsoWeekStartMonday,
} from '../utils/dashboardScope';

/**
 * Resolved reporting period from the global DashboardScopeStrip.
 *
 * Action queues and KPI panels should use these dates — not local date pickers —
 * so portfolio dashboards stay aligned with PSA single-period semantics.
 *
 * @returns {{
 *   startDate: string|null,
 *   endDate: string|null,
 *   periodLabel: string,
 *   dateRangeLabel: string|null,
 * }}
 */
export const useDashboardReportingPeriod = () => {
    const { dateRange, timeRange } = useDashboardScope();

    return useMemo(() => {
        const startDate = dateRange?.start_date ?? null;
        const endDate = dateRange?.end_date ?? null;

        return {
            startDate,
            endDate,
            weekStartDate: getIsoWeekStartMonday(endDate || startDate),
            periodLabel: getDashboardPeriodLabel(timeRange),
            dateRangeLabel: formatDashboardDateRangeLabel(dateRange),
        };
    }, [dateRange, timeRange]);
};

export default useDashboardReportingPeriod;
